// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__5ClNZ","bigColWidth":"Table_bigColWidth__1gOij","biggerColWidth":"Table_biggerColWidth__2xglm","row":"Table_row__3E2s6","col":"Table_col__1rAdP"};